/*
 * Matomo.jsx 08.02.2018
 *
 * (c) 2018 ergovia GmbH
 */
import React from 'react';

/**
 * Die Matomo Komponente führt die initale Tracking-Funktionalität in die App ein
 */
// eslint-disable-next-line no-process-env
const matomoSiteId = process.env.BILDUNGSMANAGER_MATOMO_SITE_ID;

class Matomo extends React.Component {

    // eslint-disable-next-line class-methods-use-this
    componentDidMount() {

        const _paq = window._paq || [];

        const humanReadbleNumber = 1000;
        window.sessionStorage.setItem('sessionIdent', `${new Date().getTime()};${(Math.random() * humanReadbleNumber).toFixed(0)}`);
        window._paq.push(['setUserId', window.sessionStorage.getItem('sessionIdent')]);

        /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
        _paq.push(['trackPageView']);

        _paq.push(['enableLinkTracking']);

        (() => {
            const uri = '//web.all-evsrv.de/';
            _paq.push(['setTrackerUrl', `${uri}piwik.php`]);
            _paq.push(['setSiteId', matomoSiteId]);
            const dom = document,
                matomoScriptTag = dom.createElement('script'),
                firstScriptTag = dom.getElementsByTagName('script')[0];
            matomoScriptTag.type = 'text/javascript';
            matomoScriptTag.async = true;
            matomoScriptTag.defer = true;
            matomoScriptTag.src = `${uri}piwik.js`;
            firstScriptTag.parentNode.insertBefore(matomoScriptTag, firstScriptTag);
        })();
    }

    // eslint-disable-next-line class-methods-use-this
    render() {

        return null;
    }
}

export default Matomo;



// WEBPACK FOOTER //
// ./src/de/ergovia/components/core/Matomo.jsx